"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionBoxDecoder = exports.VersionBox = void 0;
const simple_encoding_1 = require("@simonbackx/simple-encoding");
/**
 * When you need to store data for a long period, a VersionBox can be very usefull. It saves the version of the data in it's encoding.
 * During decoding, it reads the version and continues decoding the data using the provided version instead of the version in the context.
 */
class VersionBox {
    constructor(data) {
        this.data = data;
    }
    encode(context) {
        if (Array.isArray(this.data)) {
            return {
                data: this.data.map(d => d.encode(context)),
                version: context.version
            };
        }
        if (simple_encoding_1.isEncodeable(this.data)) {
            return {
                data: this.data.encode(context),
                version: context.version
            };
        }
        throw new Error("Unexpected non-encodeable data in versionbox");
    }
}
exports.VersionBox = VersionBox;
class VersionBoxDecoder {
    constructor(decoder) {
        this.decoder = decoder;
    }
    decode(data) {
        // Set the version of the decoding context of "data"
        const context = data.field("data");
        context.context.version = data.field("version").integer;
        return new VersionBox(context.decode(this.decoder));
    }
}
exports.VersionBoxDecoder = VersionBoxDecoder;
//# sourceMappingURL=VersionBox.js.map